export class Postal{
    Titulo: string;
    Idpostal: number;
    destinatarios = [];
    cuerpo: string;
    medio:string;
    liga: string;
    IDColaborador: string;
    NombreColaborador:string;
}